import { createContext } from 'react'

import type { EventType } from '@/services/api/schemas/events'

import type { EventsPeriod } from './eventsPeriod'

export type EventTypeFilter = EventType | 'all'

export interface EventsContextValue {
  type: EventTypeFilter
  setType: (type: EventTypeFilter) => void
  period: EventsPeriod
  setPeriod: (period: EventsPeriod) => void
  selectedId: string | null
  select: (id: string | null) => void
}

export const EventsContext = createContext<EventsContextValue | null>(null)
